import React from 'react';

class Notifications extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            changes: {}
        };

        this.onFieldChanged = this.onFieldChanged.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
    };

    onFieldChanged(e) {
        let c = this.state.changes;
        c[e.target.getAttribute('data-key')] = e.target.value == "true" ;
        this.setState({changes: c});
    }
    saveChanges(e) {
        HC_SendRequest('edit_profile', this.state.changes, this.props.onSuccess);
        this.state.changes = {};
    }

    render() {
        let changes = this.state.changes;
        let email = changes.email_on != undefined ? changes.email_on : this.props.emailOn;
        let pushOn = changes.push_on != undefined ? changes.push_on : this.props.pushOn;
        let showOnly = changes.show_only != undefined ? changes.show_only : this.props.showOnly;
        let notStyle = {flex:"0 0 180px", lineHeight:'34px'};
        let btnStyle = {display:'block', margin:'auto', marginTop:'20px' };

        let classCaption = "hc-f-l hc-f4";
        if (HC_DeviceType() != HC_CONST.SCR_DESCKTOP) {
            classCaption += " hc-text-nowrap";
            btnStyle.marginLeft = "auto";
            notStyle.flex = "0 0 150px";
        }
        let classBtn = "hc-button";
        let opts = {};
        if ($.isEmptyObject(changes)) {
            classBtn += ' hc-button-off';
            opts['disabled'] = 'disabled';
        }
        return (
            <div style={{padding:"4%"}}>
                <div className="hc-flex-display">
                    <div className={classCaption}
                         style={notStyle}>{HC_LANG.PRO_EMAIL_NOTIFICATION}</div>
                    <select className="form-control hc-f4" data-key="email_on" onChange={this.onFieldChanged}
                            value={email} style={{flex:"1 1 auto"}}>
                        <option value="true">{HC_LANG.PRO_ON}</option>
                        <option value="false">{HC_LANG.PRO_OFF}</option>
                    </select>
                </div>
                <div className="hc-flex-display" style={{marginTop:"15px"}}>
                    <div className={classCaption}
                         style={notStyle}>{HC_LANG.PRO_PUSH_NOTIFICATION}</div>
                    <select className="form-control hc-f4" data-key="push_on" onChange={this.onFieldChanged}
                            value={pushOn} style={{flex:"1 1 auto"}}>
                        <option value="true">{HC_LANG.PRO_ON}</option>
                        <option value="false">{HC_LANG.PRO_OFF}</option>
                    </select>
                </div>
                <div className="hc-flex-display" style={{marginTop:"15px"}}>
                    <div className={classCaption}
                         style={notStyle}>{HC_LANG.PRO_VIEW_FAVORITE}</div>
                    <select className="form-control hc-f4" data-key="show_only" onChange={this.onFieldChanged}
                            value={showOnly} style={{flex:"1 1 auto"}}>
                        <option value="true">{HC_LANG.PRO_ON}</option>
                        <option value="false">{HC_LANG.PRO_OFF}</option>
                    </select>
                </div>
                <button className={classBtn} {...opts} onClick={this.saveChanges}
                        style={btnStyle}>{HC_LANG.PRO_SAVE_LANG}</button>
            </div>
        );
    }
};

module.exports = Notifications;


// WEBPACK FOOTER //
// ./profile/notifications.js